export default __webpack_public_path__ + "static/repairLeatherGoods-c73b125955382e6cdf6aac8bdbbc63af.jpg";